<template>
  <div v-if="!isLoading" class="container-fluid new_Header">
    <div class="row nav_Breadcrumb">
      <div class="col">
        <nav>
          <ol class="breadcrumb">
            <li class="breadcrumb-item mx-3">
              <router-link to="/">{{$t('financialTransactions.breadcrumb_1')}}</router-link>
            </li>
            <i  v-if="userLang == 'ar'" class="fa-solid fa-chevron-left pt-1"></i>
            <i  v-else class="fa-solid fa-chevron-right pt-1"></i>
            <li class="breadcrumb-item mx-3 almarai-bold" aria-current="page">
              {{$t('financialTransactions.breadcrumb_2')}}
            </li>
          </ol>
        </nav>
      </div>
    </div>
  </div>
  <div class="container">
    <div class="text-center">
      <errorAlert v-if="hasError" :alertMessage="message" :errorNumber='errorNumber' />
    </div>

    <div v-if="isLoading" class="row justify-content-center">
      <div class="col-12 col-md-8 text-center">
        <mainloader />
      </div>
    </div>

    <div v-else class="row pt-3">
        <!-- <h6 class="almarai-bold py-2">المعاملات المالية</h6> -->
      <div class="col-12 py-2" v-for="(row, index) in rows" :key="index">
        <div class="row">
          <div class="col-auto text-center">
            <!-- <img src="/assets/images/icons/Frame-8.png" alt=""> -->
            <img v-if="row.approved" src="/assets/images/icons/Frame-success.png" class="w-50" alt="">
            <img v-else src="/assets/images/icons/Frame-false.png" class="w-50" alt="">
          </div>
          <div class="col content-center">
            <router-link :to="(row.modelName == 'MaintenanceOrders')? '/maintenancedetails/'+row.modelId : (row.modelName == 'Properties')? '/propertydetails/'+row.modelId :
              (row.modelName == 'PropReservations')? '/propReservationDetails/'+row.modelId : (row.modelName == 'Reservations')? '/previewdetails/'+row.modelId:
              (row.modelName == 'Users')? '/wallet' : (row.modelName == 'PropertyPayments')? '/rental/'+row.modelId : '#'"
            >
              <div v-if="row.description">
                {{row.description}}
              </div>
              <div v-else>description not found</div>

              <div>
                {{moment(row.createdAt).format('L')}}
              </div>
            </router-link>
          </div>
          <div class="col text-start content-center">
            <div :class="(row.approved)? 'green-color' : 'red-color'">
              {{row.amount}} <span class="mx-1 green-color-F icon-saudi_riyal_bold_new"></span>
            </div>
          </div>
        </div>
        <hr>
      </div>
    </div>

    <div class="row pt-3 financial" v-if="!isLoading && !rows.length">
      <div class="col text-center">
        <img src="/assets/images/icons/Frame-$.png" alt="">
        <h5 class="almarai-bold pt-3">{{$t('financialTransactions.title_1')}}</h5>
        <h6>{{$t('financialTransactions.title_2')}}</h6>
      </div>
    </div>
  </div>
</template>
<script>
import moment from 'moment';
export default {
  name: "financialtransactions",
  data(){
    return{
      isLoading: true,
      hasError: false,
      message: '',
      errorNumber: null,
      rows:[],
      userLang: 'ar',
    }
  },
  methods:{
    paymentsList(){
      this.hasError = false;
      this.$http.get("/api/payments/paymentsList").then(res => {
        // console.log(res);
        this.rows = res.data.rows;
        window.scrollTo({top:0, behavior: 'smooth'});
        this.isLoading = false;
      }).catch(err => {
        // console.log(err);
        this.isLoading = false;
        [this.message, this.errorNumber] = this.$globalErrror(err, true);
        this.hasError = true;
      });
    },
    moment,
    formatDate(){
      this.nowTime = new Date();
      this.hours = this.nowTime.getHours().toString().padStart(2, '0');
      this.minutes = this.nowTime.getMinutes().toString().padStart(2, '0');
      this.formattedTime = `${this.hours}:${this.minutes}`;
      // console.log(this.formattedTime); 
    },
  },
  created(){
    this.paymentsList();
    this.formatDate();
    window.scrollTo({top:0, behavior: 'smooth'});
    this.userLang = localStorage.getItem('lang') ?? 'ar';
  }
}
</script>